interface FaqItem {
  q: string;
  a: string;
}

const faqs: FaqItem[] = [
  {
    q: '贝勒漫画网需要注册才能阅读吗？',
    a: '部分免费漫画无需注册即可在线阅读，注册账号后可以享受收藏、书签同步、个性化推荐等更多功能。新用户注册即送30天VIP体验，畅读全部热门漫画资源。',
  },
  {
    q: '贝勒漫画APP在哪里下载？',
    a: '您可以在本页面的APP下载区域找到iOS和Android双平台下载入口。iOS用户前往App Store搜索"贝勒漫画"下载，Android用户可直接下载APK安装包，均为官方正版应用。',
  },
  {
    q: '贝勒漫画网的更新频率是怎样的？',
    a: '平台每日同步更新热门连载漫画，热门作品通常每周更新1-2话。韩漫、日漫、国漫均有专门的更新日历，您可以在网站或APP中订阅追更提醒，第一时间获取更新通知。',
  },
  {
    q: '贝勒漫画支持离线阅读吗？',
    a: '支持！贝勒漫画APP提供离线下载功能，您可以将喜欢的漫画章节提前下载到本地，在没有网络的环境中也能正常阅读。下载的漫画保存在APP内，不占用系统相册空间。',
  },
  {
    q: '如何联系贝勒漫画进行版权合作或投稿？',
    a: '我们欢迎漫画作者、版权方和内容创作者与我们合作。请发送邮件至 contact@beilecomic.com，我们的版权合作团队会在3个工作日内与您联系，沟通具体的合作方案。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">常见问题</h2>
          <p className="text-sm text-foreground-500">关于贝勒漫画的常见疑问，这里都能找到答案</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 border border-background-200/60"
            >
              <h3 className="text-sm font-medium text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 font-heading text-lg flex-shrink-0 leading-tight">Q</span>
                <span>{faq.q}</span>
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed pl-6">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}